import React from "react";

const ChrMetricContainer = (props) => {
  const className = `d-flex flex-column ${props.className}`;
  return (
    <div className={ className }>
      { props.children }
    </div>
  )
}

export default ChrMetricContainer;
